// Material UI
import { makeStyles } from '@material-ui/core';
// Constant
import Colors from '../../../../constants/Colors';

export default makeStyles({
  button: {
    backgroundColor: Colors.BACKGROUND_COLOR_LIGHT,
    color: Colors.SECONDARY_FONT_COLOR,
    padding: '6px',
  },
  icon: {
    color: Colors.SHIP_GRAY,
  },
});
